export const removeAccents = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}
export const prepareForSearch = (str: string) => {
    if (str) {
        return removeAccents(str.toLowerCase()).trim()
    }
    return str
}
export const stringMatchWithSearch = (searchValue: string, value: string) => {
    const valueParsed = prepareForSearch(value)
    const searchParsed = prepareForSearch(searchValue)
    if (searchValue === '' || (valueParsed && valueParsed.includes(searchParsed))) {
        return true
    }
    return false
}

export const stringMatchWithExactSearch = (searchValue: string, value: string) => {
    const valueParsed = prepareForSearch(value)
    const searchParsed = prepareForSearch(searchValue)
    if (searchValue === '' || (valueParsed && valueParsed === searchParsed)) {
        return true
    }
    return false
}

export const numberMatchWithSearch = (searchValue: number, value: number | number[]) => {
    if(Array.isArray(value)){
        for (const myVal of value) {
            if (parseFloat(String(searchValue)) === parseFloat(String(myVal))) {
                return true
            }
        }
    }else {
        if (parseFloat(String(searchValue)) === parseFloat(String(value))) {
            return true
        }
    }
    return false
}

export const checkBiggerDateSearch = (searchDate: string, value: string) => {
    const parsedValue = new Date(value)
    const parsedSearchDate = new Date(searchDate)
    if (parsedValue >= parsedSearchDate){
        return true
    }
    return false
}

export const checkSmallerDateSearch = (searchDate: string, value: string) => {
    const parsedValue = new Date(value)
    const parsedSearchDate = new Date(searchDate)
    if (parsedValue <= parsedSearchDate){
        return true
    }
    return false
}